import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../muiComponents/Icon';
import '../../stylesheets/stylesLayout/lateralMenu.scss';
import useUserProfile from '../../customHooks/useUserProfile';
import { ownerPortalMenu, zinantisMenu } from '../../utils/menusData';
import { useHotelOwner } from '../../contexts/HotelOwnerContext';

const OwnerPortalLateralMenu = () => {
    const [isOpenMenu, setIsOpenMenu] = useState(true);
    const { settings, translate } = useUserProfile();
    const { ownerData } = useHotelOwner();
    const { adminUser } = settings;

    return (
        <nav
            className={`menu-list__container ${
                isOpenMenu ? '--expanded' : '--collapsed'
            }`}
        >
            <div className='menu-list'>
                <div>
                    <h6
                        className={`menu-list__title ${
                            isOpenMenu ? '' : '--collapsed'
                        }`}
                    >
                        {translate('home')}
                    </h6>
                    <ul>
                        {ownerPortalMenu.map((item, i) => {
                            const { link, text, icon } = item;

                            return (
                                <li key={i} className='menu__item'>
                                    <NavLink
                                        to={link}
                                        className='menu-item__link'
                                    >
                                        <Icon
                                            iconName={icon}
                                            className='menu-item__icon'
                                            fontSize='medium'
                                        />
                                        <span className='menu-item__text'>
                                            {translate(text)}
                                        </span>
                                    </NavLink>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {ownerData && ownerData.zinantisMembership && adminUser ? (
                    <div>
                        <h6
                            className={`menu-list__title ${
                                isOpenMenu ? '' : '--collapsed'
                            }`}
                        >
                            zinantis
                        </h6>
                        <ul>
                            {zinantisMenu.map((item, i) => {
                                const { link, text, icon } = item;
                                return (
                                    <li key={i} className='menu__item'>
                                        <NavLink
                                            to={link}
                                            className='menu-item__link'
                                        >
                                            <Icon
                                                iconName={icon}
                                                className='menu-item__icon'
                                                fontSize='medium'
                                            />
                                            <span className='menu-item__text'>
                                                {translate(text)}
                                            </span>
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ) : (
                    ''
                )}
            </div>
            <Icon
                iconName='KeyboardArrowLeft'
                className={`menu__colapse-icon ${
                    isOpenMenu ? '--expanded' : '--collapsed'
                }`}
                onClick={() => setIsOpenMenu(prev => !prev)}
            />
        </nav>
    );
};

export default OwnerPortalLateralMenu;
